import { render } from "./DataProcessingComponent.vue?vue&type=template&id=64f1681e&scoped=true"
import script from "./DataProcessingComponent.vue?vue&type=script&lang=js"
export * from "./DataProcessingComponent.vue?vue&type=script&lang=js"

import "./DataProcessingComponent.vue?vue&type=style&index=0&id=64f1681e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f1681e"]])

export default __exports__